import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-volta',
  templateUrl: './volta.component.html',
  styleUrls: ['./volta.component.scss']
})
export class VoltaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
